export const EventMfeRequest = 'cp-event';
export const EventMfeResponse = 'cp-event-response';

export const eventTypes = {
    dynamicSettings: 'ds',
};

export interface CPMfeEvent<T> {
    event: string;
    data: T;
    id: number;
}
